module.exports = __webpack_public_path__ + "static/media/email@2x.a32885af.png";